import { render, staticRenderFns } from "./SlidingPanel.vue?vue&type=template&id=1278f274"
import script from "./SlidingPanel.vue?vue&type=script&lang=js"
export * from "./SlidingPanel.vue?vue&type=script&lang=js"
import style0 from "./SlidingPanel.vue?vue&type=style&index=0&id=1278f274&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports